<template>
  <div>
    <!--位置监控-->
    <div style="
        display: flex;
        align-items: center;
        margin-top: 15px;
        margin-bottom: 10px;
      ">
      <div style="flex: 1">
        <span class="page_title">{{ $t("locateVehicle.page_title") }}</span>
        <span style="font-size: 12px; color: #ff8c00; margin-left: 30px"><i class="iconfont icon-icon_prompt2"
            style="font-size: 16px; margin-right: 4px"></i>{{ $t("locateVehicle.selectvehicles") }}</span>
      </div>
      <div>
        <el-checkbox v-model="checked" :label="$t('locateVehicle.autoRefresh') + '(15s)'"></el-checkbox>

        <el-button size="mini" style="margin-left: 30px" @click="onRefreshClick">{{ $t("public.refresh") }}</el-button>
      </div>
    </div>
    <div style="width: 100%; height: calc(100vh - 190px)">
      <div style="width: 100%; height: 100%;display: flex;">
        <div style="height: 100%;flex: 1;">

          <KingLongMap ref="map" :coordsType="9" @LoadCompleted="MapLoadCompleted" />
        </div>
        <div :style="{ width: infoCol + '%' }" style="height: 100%;">
          <vehicle_info ref="vehicleinfo" @hide="hideEvent" style="width: 100%;" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap";
import vehicle_info from "./components/vehicle_info";
import { VeicleLastGpsList } from "./vehicleLastGpsList";
import { mapState } from "vuex";
import settings from "@/settings";
import { HashTable } from "@/utils/HashTable";
import { gcj02tobd09, wgs84togcj02 } from "@/utils/lnglat"
export default {
  name: "locateVehicle",
  components: {
    KingLongMap,
    vehicle_info,
  },
  data() {
    return {
      checked: true,
      lastGpsInfo: undefined,
      monitorList: [],
      index: 0,
      mapCol: 100,
      infoCol: 0,
      vlist: undefined,
      deviceMap: {},
      timer: undefined,
      mapLoaded: false,
      monitor_vid: undefined,
      monitor_isover: false,
      monitor_info: undefined,
      currentGpsInfo: undefined,
    };
  },
  destroyed() {
    

  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  created() {

  },
  computed: {
    ...mapState({
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
    }),
  },
  watch: {
    selectedVehicles() {
      //这个函数，会一次性的调用多次
      if (this.selectedVehicles.length == 0) {
        this.$refs.vehicleinfo.hide();
      }


      //把所有选中的车辆的终端编号输出
      this.updateVehicleList();
    },
    "$route.query.vid": {
      handler() {
        this.monitor_vid = this.$route.query.vid;
        this.monitor_isover = false;
        this.monitor_info = JSON.parse(localStorage.getItem("monitor_vehicle"));

      },
      immediate: true,
    },
  },

  methods: {
    MapLoadCompleted() {
      this.mapLoaded = true;
      if (this.currentGpsInfo) {
        this.lastGpsInfo.batchUpdateGps(this.currentGpsInfo);
      }
    },
    hideEvent() {
      this.infoCol = 0;
      this.mapCol = 100;
    },
    updateVehicleList() {
      var data = [];
      this.vlist.clear();
      this.selectedVehicles.forEach((element) => {
        if (element.treeLevel == 5) {
          // if (this.vlist.contains(element.mobile)) {
          //   this.vlist.update(element.mobile, { ismonitor: 2 });
          // } else {
          data.push(element.mobile);//监控中
          this.deviceMap[element.mobile] = element;
          this.vlist.add(element.mobile, { ismonitor: 1 });
          // }
        }
      });

      // this.vlist.keys((v) => {
      //   var k = this.vlist.items(v);
      //   if (k.ismonitor == 1) {
      //     data.push(v);//监控中
      //   }
      //   if (k.ismonitor == 3) {
      //     this.vlist.remove(v);
      //   }
      //   k.ismonitor = 3;
      // });

      this.lastGpsInfo.updateVehicles(this.selectedVehicles);

      this.getLastGps(data);
    },
    onRefreshClick() {
      this.getLastGps();
    },
    getLastGps(data) {
      if (!data) {
        data = [];
        this.vlist.keys((v) => {
          data.push(v);
        });
      }
      //todo 
      if (data && data.length > 0) {

        this.getLastGpsMock(data);
      }
      else {
        //清楚所有车辆的GPS
        this.lastGpsInfo.clearAll();
      }



    },

    // 模拟数据接口 - 批量获取车辆GPS信息
    getLastGpsMock(vehicleIds) {

      const mockGpsList = [];
      this.$api.QueryVehicleLastGpsMulti({
        DeviceNos: vehicleIds,
      }).then(res => {

        if (res.code == 200) {
          res.data.forEach((element) => {


            const gpsInfo = {
              VehicleID: this.deviceMap[element.deviceNo].nodeValue,
              Lon: parseFloat(element.longitude),
              Lat: parseFloat(element.latitude),
              Speed: parseFloat(element.speed),
              Direction: parseFloat(element.direction),
              // GPSDateTime: new Date().toISOString(),
            };

            //异常定位的判断
            // if (
            //   !gpsInfo.Lon ||
            //   !gpsInfo.Lat ||
            //   gpsInfo.Lon > 180 ||
            //   gpsInfo.Lon < -180 ||
            //   gpsInfo.Lat > 90 ||
            //   gpsInfo.Lat < -90
            // ) {
            //   return;
            // }

            // 如果是百度地图，转换坐标

            if (this.$store.getters.mapType === 'baidu') {
              var statsZone = this.deviceMap[element.deviceNo].statsZone;
              if (statsZone != 8) {
                var t = wgs84togcj02(gpsInfo.Lon, gpsInfo.Lat);
                gpsInfo.Lon = t[0];
                gpsInfo.Lat = t[1];

              } else {

                var t = gcj02tobd09(gpsInfo.Lon, gpsInfo.Lat);
                gpsInfo.Lon = t[0];
                gpsInfo.Lat = t[1];
              }

            }

            mockGpsList.push(gpsInfo);

          });


          // 批量更新GPS
          if (!this.mapLoaded) {
            this.currentGpsInfo = mockGpsList;
          } else {
            this.currentGpsInfo = undefined;
            this.lastGpsInfo.batchUpdateGps(mockGpsList);
          }
        }
      })



      // 通过车辆树直接点击过来的车辆监控
      if (this.monitor_vid) {
        const monitorGps = mockGpsList.find(g => g.VehicleID === this.monitor_vid);
        if (monitorGps && !this.monitor_isover) {
          this.monitor_isover = true;
          this.$bus.$emit("showOnMapEvent", {
            vehicleInfo: this.monitor_info,
            gpsInfo: monitorGps,
          });
        }
      }
    },
  },

  mounted() {
    const currentPath = this.$route.path
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      const renderTime = Date.now() - startTime
      delete settings.routeStartTime[currentPath]
    }

    var _this = this;
    this.$store.dispatch("app/openSideBar");
    this.monitorList = [];

    this.vlist = new HashTable();

    if (this.timer != null) clearInterval(this.timer);

    if (this.timer == null) {
      this.timer = setInterval(() => {
        if (this.checked) {
          this.getLastGps();
        }
      }, 15 * 1000);
    }

    if (!this.lastGpsInfo) {
      this.lastGpsInfo = new VeicleLastGpsList();
      this.lastGpsInfo.init(this.$refs.map);
    }

    if (this.selectedVehicles.length > 0) {
      this.updateVehicleList();
    }

    this.$bus.$on("showOnMapEvent", (param) => {
      if (this.$refs.vehicleinfo)
        this.$refs.vehicleinfo.show(
          param.vehicleInfo.vehicleName,
          param.vehicleInfo
        );
      this.infoCol = 30;
      this.mapCol = 70;
    });

    this.$bus.$on("onSingleVehicleMonitor", (param) => {
    });
  },
};
</script>
<style></style>